/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Szybki filtr z kart KPI (liczony względem aktywnego cyklu).
 * @export
 * @enum {string}
 */

export const TeamDevelopmentFilterDto = {
    All: 'ALL',
    PlansToApprove: 'PLANS_TO_APPROVE',
    OverdueSteps: 'OVERDUE_STEPS',
    WithoutPlan: 'WITHOUT_PLAN'
} as const;

export type TeamDevelopmentFilterDto = typeof TeamDevelopmentFilterDto[keyof typeof TeamDevelopmentFilterDto];



